import {
  CE_RENDER_PREVIEW_IMAGE_READY,
  CE_RENDER_PREVIEW_IMAGE_WAIITNG_FOR_RENDER,
  CE_RENDER_PREVIEW_IMAGE_ERROR,
  CE_RENDER_PREVIEW_IMAGE_REQUESTING_RENDER,
  CE_RENDER_PREVIEW_IMAGE_WAITING_FOR_PUBLISH,
  CE_RENDER_PREVIEW_IMAGE_NO_CONTENT_TO_PREVIEW,
} from "@js/actions/studio/render_preview_image.js";

import {
  mergePreviewImageWithoutBump,
  getPreviewHashForContent,
} from "@js/helpers/state.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_RENDER_PREVIEW_IMAGE_REQUESTING_RENDER:
      return mergePreviewImageWithoutBump(state, action.client_content_id, {
        preview_hash: getPreviewHashForContent(state, action.client_content_id),
        step: "requesting_render",
      });
    case CE_RENDER_PREVIEW_IMAGE_WAITING_FOR_PUBLISH:
      return mergePreviewImageWithoutBump(state, action.client_content_id, {
        image_url: null,
        step: "waiting_for_publish",
      });
    case CE_RENDER_PREVIEW_IMAGE_WAIITNG_FOR_RENDER:
      return mergePreviewImageWithoutBump(state, action.client_content_id, {
        image_url: "",
        step: "waiting_for_render",
      });
    case CE_RENDER_PREVIEW_IMAGE_ERROR:
      return mergePreviewImageWithoutBump(state, action.client_content_id, {
        step: "error",
        error_generation_id: state.sync.data_generation_id,
      });
    case CE_RENDER_PREVIEW_IMAGE_READY:
      return mergePreviewImageWithoutBump(state, action.client_content_id, {
        step: "ready",
        image_url: action.image_url,
      });
    case CE_RENDER_PREVIEW_IMAGE_NO_CONTENT_TO_PREVIEW:
      return mergePreviewImageWithoutBump(state, action.client_content_id, {
        step: "no_content_to_preview",
        image_url: null, //Clear our preview image if we had one already loaded
      });
    default:
      return state;
  }
};
